import type { RouteObject } from 'react-router';

import { lazy } from 'react';
import { Navigate } from 'react-router';

import { CONFIG } from 'src/global-config';

import { authRoutes } from './auth';
import { adminRoutes } from './admin';
import { qrCodeRoutes } from './qr-code';
import { dashboardRoutes } from './dashboard';
import { examinationRoutes } from './examination';
import { invitationsRoutes } from './invitations';
import { mandatoryUnitRoutes } from './mandatory-units';

const Page404 = lazy(() => import('src/pages/error/404'));

export const routesSection: RouteObject[] = [
  {
    path: '/',
    element: <Navigate to={CONFIG.auth.redirectPath} replace />,
  },

  // Auth
  ...(import.meta.env.DEV ? authRoutes : []),

  // Dashboard
  ...dashboardRoutes,

  // Invitations
  ...invitationsRoutes,

  // Admin
  ...adminRoutes,

  // Examination
  ...examinationRoutes,

  // Mandatory Unit
  ...mandatoryUnitRoutes,

  // QR Code
  ...qrCodeRoutes,

  // No match
  { path: '*', element: <Page404 /> },
];
